import { createFileRoute } from "@tanstack/react-router"
import { AccountPage } from "@/app"

export const Route = createFileRoute("/(user)/t/$tenantSlug/account")({
  component: RouteComponent,
})

function RouteComponent() {
  return <AccountPage />
}
